import { createQueryKeys } from '@lukemorales/query-key-factory'

import type { UseQueryOptionsWithoutQueryFn } from '~/types/util/tanstack-query'

import { responseDataTypeName, useFetchPreferences } from './useFetchPreferences'

export const queryKeys = createQueryKeys(responseDataTypeName, {
  getByKey: ({ key }: { key: MaybeRefOrGetter<string> }) => ({ queryKey: [toValue(key)] }),
})

const getByKey = ({ key, useQueryOptions }: { key: MaybeRefOrGetter<string>, useQueryOptions?: UseQueryOptionsWithoutQueryFn }) => {
  const { getByKey } = useFetchPreferences()
  const { activeWorkspaceId, workspace } = useAuth()

  return useQuery({
    ...queryKeys.getByKey({ key }),
    queryFn: () => getByKey({
      key: toValue(key),
      workspaceId: unref(activeWorkspaceId) || '',
    }),
    enabled: () => !!unref(workspace),
    ...useQueryOptions,
  })
}

export const useQueryPreferences = {
  getByKey,
}
